// Root route (/) — intentionally ungated (landing, no single Resource).
export const dashboardLoader = () => null;
